import PropTypes from 'prop-types';
import React from 'react';
import moment from 'moment';
import VettingTerms from './VettingTerms';
import './LeadVettingStyle.less';
import VettingFlowSteps from './VettingFlowSteps';
import VettingMoreInformation from './VettingMoreInfrmation';
import { VETTING_STAGES } from '../../../Constants/Common';

class LeadVettingFormNew extends React.Component {
  render() {
    const {
      fields,
      agreeToTerms,
      onSubmit,
      vettingStage,
      product,
      isLoading,
      submitVettingStep3,
      submitVettingStep1,
      submitVettingStep2,
      updateFields,
    } = this.props;

    const vettingSubmitMoreInfo = (values) => {
      onSubmit({
        email: fields.email,
        country: values.country,
        website: values.website,
        description: values.description,
      });
    };

    const urlParams = new URLSearchParams(window.location.search);
    const campaignName = urlParams.get('utm_campaign');
    const utmMedium = urlParams.get('utm_medium');
    const utmKeyword = urlParams.get('utm_keyword');
    const utmContent = urlParams.get('utm_content');
    const utmSource = urlParams.get('utm_source');
    const hsString = urlParams.get('hsCtaTracking');
    const createCookies = () => {
      if (campaignName) {
        document.cookie = `campaign=${campaignName}; expires=${moment().add(7, 'days').toDate()}; path=/`;
      }
      if (utmMedium) {
        document.cookie = `utm_medium=${utmMedium}; expires=${moment().add(7, 'days').toDate()}; path=/`;
      }
      if (utmKeyword) {
        document.cookie = `utm_keyword=${utmKeyword}; expires=${moment().add(7, 'days').toDate()}; path=/`;
      }
      if (utmContent) {
        document.cookie = `utm_content=${utmContent}; expires=${moment().add(7, 'days').toDate()}; path=/`;
      }
      if (utmSource) {
        document.cookie = `utm_source=${utmSource}; expires=${moment().add(7, 'days').toDate()}; path=/`;
      }
      if (hsString) {
        const hsStringSliced = hsString.split('|');
        const ctaId = hsStringSliced[0];
        document.cookie = `cta_id=${ctaId}; expires=${moment().add(7, 'days').toDate()};path=/`;
      }
    };
    createCookies();

    return vettingStage === VETTING_STAGES.terms ? (
      <VettingTerms onSubmit={agreeToTerms} product={product} />
    ) : vettingStage === VETTING_STAGES.vettingSteps ? (
      <VettingFlowSteps
        submitVettingStep1={submitVettingStep1}
        submitVettingStep2={submitVettingStep2}
        submitVettingStep3={submitVettingStep3}
        isLoading={isLoading}
        product={product}
        fields={fields}
        updateFields={updateFields}
      />
    ) : vettingStage === VETTING_STAGES.moreInfo ? (
      <VettingMoreInformation onSubmit={vettingSubmitMoreInfo} isLoading={isLoading} />
    ) : null;
  }
}

LeadVettingFormNew.propTypes = {
  onSubmit: PropTypes.func,
  isLoading: PropTypes.bool,
  submitVettingStep1: PropTypes.func,
  submitVettingStep2: PropTypes.func,
  submitVettingStep3: PropTypes.func,
  product: PropTypes.string,
  vettingStage: PropTypes.string,
  agreeToTerms: PropTypes.func,
  fields: PropTypes.object,
  updateFields: PropTypes.func,
};

export default LeadVettingFormNew;
